import { render } from "./FTUE.vue?vue&type=template&id=62557efc&scoped=true"
import script from "./FTUE.vue?vue&type=script&lang=js"
export * from "./FTUE.vue?vue&type=script&lang=js"

import "./FTUE.vue?vue&type=style&index=0&id=62557efc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62557efc"]])

export default __exports__